import { Checkbox as Checkbox$1, Checkmark } from '@accessible/checkbox';
import useId from '@accessible/use-id';
import { CheckIcon } from '@koaly/koaly-ui-icons';
import { getVariantToken, getSizeToken, rem, marginBottomSpacing } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import styled from 'styled-components';
import { Label } from '../Label/Label.js';
import { StatusMessages } from '../StatusMessages/StatusMessages.js';

const StyledCheckmark = styled.div `
  display: block;
  box-shadow: ${({ theme }) => theme.elevations[1]},
  0 0 0 1px ${getVariantToken('checkbox', 'borderColor')};
  border-radius: ${getSizeToken('checkbox', 'borderRadius')};
  color: ${getVariantToken('checkbox', 'color')};

  svg {
    display: none;
  }

  &:focus, &.focus {
    box-shadow: ${({ theme }) => theme.elevations[1]},
    0 0 0 ${getSizeToken('checkbox', 'borderSizeFocus')} ${getVariantToken('checkbox', 'borderColorFocus')};
  }

  &:checked, &.checked {
    background-color: ${getVariantToken('checkbox', 'backgroundColorChecked')};
    color: ${getVariantToken('checkbox', 'colorChecked')};

    svg {
      display: block;
    }
  }

  &:disabled, &.disabled {
    background-color: ${getVariantToken('checkbox', 'backgroundColorDisabled')};
    color: ${getVariantToken('checkbox', 'colorCheckedDisabled')};
  }

  width: ${({ size }) => getSizeToken('checkbox', 'size', size)};
  height: ${({ size }) => getSizeToken('checkbox', 'size', size)};
  font-size: ${({ size }) => getSizeToken('checkbox', 'size', size)};
`;
const StyledStatusMessages = styled(StatusMessages) `
  padding-top: ${rem(12)};
`;
const StyledCheckbox = styled.div `
  ${StyledCheckmark} {
    margin-right: ${rem(12)}
  }

  label {
    position: relative;
    display: flex;
  }

  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
`;
const Checkbox = withExtra(({ id, name, label, checked, disabled, size, onChange, defaultChecked, spaceAfter, errors }, ref) => {
    const inputId = useId(id || name, 'checkbox-');
    return (React.createElement(StyledCheckbox, { spaceAfter: spaceAfter },
        React.createElement(Label, { htmlFor: inputId },
            React.createElement(Checkbox$1, { checked: checked, disabled: disabled, name: name, onChange: onChange, defaultChecked: defaultChecked, ref: ref, id: inputId },
                React.createElement(Checkmark, { checkedClass: "checked", uncheckedClass: "unchecked" },
                    React.createElement(StyledCheckmark, { size: size },
                        React.createElement(CheckIcon, null)))),
            label),
        errors && (React.createElement(StyledStatusMessages, { type: "danger", id: `${inputId}-error`, items: typeof errors === 'string' ?
                errors.replace('{label}', label) :
                errors.map(x => x.replace('{label}', label)) }))));
}, { name: 'Checkbox' });
Checkbox.defaultProps = {
    size: 'medium',
};

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
